var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYtBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.881 7.71725C12.8535 6.63376 8.92773 4.59766 8.92773 4.59766L14.1618 8.1156C14.1622 8.1156 13.2083 8.64443 14.881 7.71725Z",
    fill: "#003C97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30899 15.6907C5.0977 15.6131 3.65935 15.5434 2.77524 15.3612C2.17709 15.2402 1.6573 14.9715 1.27617 14.5817C0.981603 14.2868 0.747346 13.8367 0.565603 13.2123C0.409705 12.6921 0.348987 12.2593 0.262423 11.202C0.12991 8.81599 0.0983208 6.86523 0.262423 4.68553C0.397808 3.48184 0.463449 2.05292 1.36273 1.21928C1.78735 0.829123 2.2813 0.578047 2.83596 0.474252C3.70242 0.309739 7.39391 0.179688 11.2154 0.179688C15.0284 0.179688 18.7281 0.309739 19.5953 0.474252C20.2883 0.604303 20.9381 0.994047 21.3197 1.49661C22.1402 2.78728 22.1545 4.3922 22.2378 5.64758C22.2723 6.24574 22.2723 9.64225 22.2378 10.2404C22.1082 12.2244 22.004 12.9264 21.7094 13.6541C21.5272 14.1136 21.3718 14.3561 21.1026 14.6248C20.6805 15.0383 20.1424 15.3134 19.5601 15.4133C15.9158 15.6874 12.8212 15.7469 9.30899 15.6907ZM14.8897 7.71856C12.8622 6.63507 10.9209 5.63035 8.93647 4.59035V10.8123C11.0247 9.67712 13.2261 8.63712 14.8983 7.70994L14.8897 7.71856Z",
    fill: "#0262F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtBl);
export default __webpack_public_path__ + "static/media/yt-bl.61c132c7012226e561a13ce32da0b0d3.svg";
export { ForwardRef as ReactComponent };